<template>
  <div class="invoice">
    <div class="title">
      <h2>开具发票</h2>
    </div>
    <div class="tabs" v-if="!showInvoiceInfo">
      <div class="bar-list">
        <div
          :class="`tab-bar ${selectedTab === item.id ? 'selected' : ''}`"
          v-for="(item, index) in barList"
          :key="index"
          @click="toggleTab(item.id)"
        >{{ item.text }}</div>
      </div>
      <div class="content" v-if="selectedTab === 0">
        <ul v-if="orderList.length > 0">
          <li class="table-title">
            <label for="typeall">
              <input
                id="typeall"
                type="checkbox"
                class="invoice-checkbox"
                name="itype"
                data-type="100"
                :checked="allChecked"
                @change="toggleAllOrder"
            /></label>
            <p>订单名称</p>
            <p>订单编号</p>
            <p>实付金额</p>
            <p>发票</p>
          </li>
          <li class="table-row" v-for="(item, index) in orderList" :key="index">
            <input
              type="checkbox"
              class="invoice-checkbox"
              :checked="selectedOrderList.includes(item.id)"
              @change="toggleOrderId(item, $event)"
              :disabled="item.is_invoice"
            />
            <p v-html="item.title"></p>
            <p v-html="item.number"></p>
            <p v-html="item.realPayAmount"></p>
            <p v-html="item.is_invoice ? '已申请' : '未申请'"></p>
          </li>
        </ul>
        <h3 class="no-ticket" v-else>暂无订单</h3>
        <div class="invoice-pages" v-if="orderList.length > 0">
          <div @click="openInvoice">开具发票</div>
          <p>可开具发票 <span>￥{{ totalAmount }}</span>，已选择订单总额 <span
          >￥{{ checkedAmount }}</span></p>
        </div>
      </div>
      <div class="content" v-else>
        <ul v-if="invoiceList.length > 0">
          <li class="table-title">
            <p>订单名称</p>
            <p>订单编号</p>
            <p>实付金额</p>
            <p>发票类型</p>
            <p>发票状态</p>
          </li>
          <li class="table-row" v-for="(item, index) in invoiceList" :key="index">
            <p v-html="item.orderTitle"></p>
            <p v-html="item.number"></p>
            <p v-html="item.realPayAmount"></p>
            <p v-html="item.typeName"></p>
            <p v-html="item.statusName"></p>
          </li>
        </ul>
        <h3 class="no-ticket" v-else>暂无发票</h3>
      </div>
    </div>
    <div class="info" v-else>
      <div class="bar-list">
        <div class="tab-bar">发票信息</div>
      </div>
      <div class="content">
        <div class="input-wrapper">
          *发票金额:
          <div class="input-content">
            <p class="amount">¥{{ invoiceAmount }}</p>
          </div>
        </div>
        <div class="input-wrapper">
          *发票类型:
          <div class="input-content invoice-type">
            <label for="typeone"
            ><input
              id="typeone"
              type="radio"
              name="itype"
              data-type="1"
              @click="toggleType"
            />会议费</label>
            <label for="typetwo"
            ><input
              id="typetwo"
              type="radio"
              name="itype"
              data-type="2"
              @click="toggleType"
            />培训费</label>
            <label for="typethree"
            ><input
              id="typethree"
              type="radio"
              name="itype"
              data-type="3"
              @click="toggleType"
            />会务费</label>
          </div>
        </div>
        <div class="input-wrapper">
          *发票内容:
          <div class="input-content">
            <label for="rzero"
            ><input type="radio" name="invoicecontent" checked="true"
            />电子普通发票</label>
          </div>
        </div>
        <div class="input-wrapper">
          *发票抬头:
          <div class="input-content">
            <input
              class="input-text"
              type="text"
              name="invoicecontent"
              v-model="invoiceTitle"
              placeholder="请填写发票抬头"
            />
          </div>
        </div>
        <div class="input-wrapper">
          *纳税人识别号:
          <div class="input-content">
            <input
              class="input-text"
              type="text"
              name="invoicecontent"
              v-model="invoiceNumber"
              placeholder="请填写纳税人识别号"
            />
          </div>
        </div>
      </div>
      <div class="bar-list">
        <div class="tab-bar">收件人邮箱</div>
      </div>
      <div class="content">
        <div class="input-wrapper">
          *电子邮箱:
          <div class="input-content">
            <input
              class="input-text"
              type="text"
              name="invoicecontent"
              id="rzero"
              v-model="email"
              placeholder="请填写电子邮箱"
            />
          </div>
        </div>
        <div class="input-wrapper">
          <div class="btn-wrapper">
            <button class="btn back" @click="goBack"
            >返回上级</button>
            <button class="btn confirm" @click="confirmInvoice"
            >确认提交</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let selectedList = []
export default {
  props: {
    token: String,
    sid: String,
    userName: String,
    userPhone: String
  },
  data () {
    return {
      barList: [
        { text: '已购订单', id: 0 },
        { text: '我的发票', id: 1 }
      ],
      selectedTab: 0,
      orderIdList: '',
      orderList: [],
      invoiceList: [],
      selectedOrderList: [], // 选中的订单列表
      totalAmount: 0, // 订单总金额
      invoiceAmount: 0, // 开票金额
      checkedAmount: 0, // 选中的订单总金额
      showInvoiceInfo: false,
      invoiceType: '',
      invoiceTitle: '',
      invoiceNumber: '',
      email: '',
      checkInvoiceList: {
        invoiceType: '发票类型',
        invoiceTitle: '发票抬头',
        invoiceNumber: '纳税人识别号',
        email: '电子邮箱'
      }
    }
  },
  // created () {
  //   if (this.sid) {
  //     this.getOrder()
  //     this.getOrderNew()
  //     this.getInvoiceList()
  //   }
  // },
  watch: {
    tabMark: {
      handler (newVal, oldVal) {
        if (newVal && newVal[0]) {
          if (newVal[1] === 0 || newVal[1] === '0') {
            this.getOrder()
            this.getOrderNew()
          } else if (newVal[1] === 1 || newVal[1] === '1') {
            this.getInvoiceList()
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    tabMark () {
      return [this.sid, this.selectedTab]
    },
    allChecked: function () {
      let flag = true
      this.orderList.map((item) => {
        if (!item.is_invoice && this.selectedOrderList.indexOf(item.id) <= -1) {
          flag = false
        }
      })
      return flag
    }
  },
  methods: {
    toggleTab (id) {
      this.selectedTab = id
    },
    toggleType (e) {
      this.invoiceType = e.target.dataset.type
    },
    goBack () {
      this.showInvoiceInfo = false
    },
    // 申请开票
    _confirmInvoice () {
      for (let key in this.checkInvoiceList) {
        console.log(key)
        if (key === 'invoiceType' && this[key] === '') {
          window.alert(`请选择${this.checkInvoiceList[key]}`)
          return false
        } else if (this[key] === '') {
          window.alert(`请填写${this.checkInvoiceList[key]}`)
          return false
        } else if (
          key === 'email' &&
          !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this[key])
        ) {
          window.alert(`请填写正确的${this.checkInvoiceList[key]}`)
          return false
        }
      }
      const data = {
        orderId: this.orderIdList,
        invoice_data: {
          title: this.invoiceTitle,
          code: this.invoiceNumber,
          phone: this.userPhone,
          name: this.userName,
          email: this.email,
          type: this.invoiceType,
          invoiceValue: this.totalAmount
        }
      }
      this.$http
        .post(
          `${this.global.urlNew.applyInvoice}?token=${this.token}`,
          data
        )
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          console.log(res)
          if (data.status === '200') {
            console.log(data)
            this.$emit('applyInvoiceSuccess')
          } else if (data.status === '1026' || data.status === '1008') {
            // window.alert('当前登录状态已过期，请重新登录');
            this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
          } else if (data.status === '1013') {
            console.log('订单不存在')
          } else {
            console.log('服务器繁忙，请重试')
          }
        })
    },
    confirmInvoice () {
      for (let key in this.checkInvoiceList) {
        console.log(key)
        if (key === 'invoiceType' && this[key] === '') {
          window.alert(`请选择${this.checkInvoiceList[key]}`)
          return false
        } else if (this[key] === '') {
          window.alert(`请填写${this.checkInvoiceList[key]}`)
          return false
        } else if (
          key === 'email' &&
          !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this[key])
        ) {
          window.alert(`请填写正确的${this.checkInvoiceList[key]}`)
          return false
        }
      }
      const data = {
        orderIds: this.orderIdList,
        invoiceData: {
          invoiceTitle: this.invoiceTitle,
          identifyNumber: this.invoiceNumber,
          phone: this.userPhone,
          name: this.userName,
          email: this.email,
          type: this.invoiceType,
          // invoiceValue: this.totalAmount,
          invoiceValue: this.invoiceAmount,
          nature: 0,
          province: '',
          city: '',
          address: '',
          remarks: ''
        }
      }
      // const params = new FormData()
      // params.append('orderId', this.orderIdList)
      console.log(data)
      this.$http
        .post(
          `${this.global.urlNew.universal.invoiceApply}?token=${this.token}&choose=1`,
          data,
          {
            emulateJSON: true
            // headers: { 'Content-Type': 'application/json' }
          }
        )
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          console.log(data)
          if (data.status === '200') {
            console.log(data)
            this.$emit('applyInvoiceSuccess')
          } else if (data.status === '1026' || data.status === '1008') {
            // window.alert('当前登录状态已过期，请重新登录');
            this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
          } else if (data.status === '1013') {
            console.log('订单不存在')
          } else {
            console.log('服务器繁忙，请重试')
          }
        })
    },
    // 全选/取消全选订单
    toggleAllOrder () {
      if (!this.allChecked) {
        this.selectedOrderList = this.orderList.map((item) => item.is_invoice ? '' : item.id)
        this.checkedAmount = this.totalAmount
      } else {
        this.selectedOrderList = []
        this.checkedAmount = 0
      }
    },
    toggleOrderId (item, ev) {
      ev.target.checked ? this.checkedAmount += parseFloat(item.realPayAmount) : this.checkedAmount -= parseFloat(item.realPayAmount)
      this.checkedAmount = parseFloat(this.checkedAmount.toFixed(2))
      const index = this.selectedOrderList.indexOf(item.id)
      if (index <= -1) {
        this.selectedOrderList.push(item.id)
      } else {
        this.selectedOrderList.splice(index, 1)
      }
    },
    // 获取订单
    getOrder () {
      let surl = `${this.global.urlNew.getMyOrder}?token=${this.token}&sid=${this.sid}&choose=1`
      this.$http.jsonp(surl)
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          console.log('order-list', data)
          if (data.status === '200') {
            this.orderList = data.data.resData
            this.computeNumberAmount()
          } else if (data.status === '1026' || data.status === '1008') {
            // window.alert('当前登录状态已过期，请重新登录');
            this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
          } else {
            console.log('服务器繁忙，请重试')
          }
        })
    },
    getOrderNew () {
      // choose: options.choose || 1, // 1-官网 2-小程序
      // source: options.source || 1, // 0-全部(默认)，1-其他会议，2-cecc
      // type: options.type || 1 // 0-全部订单，1-已支付(默认)，2-待支付
      let surl = `${this.global.urlNew.universal.order}?token=${this.token}&sid=${this.sid}&choose=1&type=0&source=1`
      this.$http.jsonp(surl)
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          console.log(data)
          // 》》》》》》
        })
    },
    openInvoice () {
      if (this.selectedOrderList.length <= 0) {
        window.alert('请选择您要开具发票的订单')
        return
      }
      selectedList = []
      this.showInvoiceInfo = true
      this.orderIdList = ''
      this.selectedOrderList.map((item) => {
        if (this.orderIdList === '') {
          this.orderIdList += item
        } else {
          this.orderIdList += ',' + item
        }
      })
      this.orderList.map((item) => {
        if (this.selectedOrderList.indexOf(item.id) > -1) {
          selectedList.push(item)
        }
      })
      this.computeInvoiceAmount()
    },
    computeNumberAmount () {
      this.totalAmount = this.orderList.reduce((accumulator, currentValue) => {
        return currentValue.is_invoice ? accumulator : (
          accumulator +
          parseFloat(currentValue.realPayAmount)
          //  * parseInt(currentValue.goodsNum)
        )
      }, 0)
    },
    computeInvoiceAmount () {
      this.invoiceAmount = selectedList.reduce((accumulator, currentValue) => {
        return (
          accumulator +
          parseFloat(currentValue.realPayAmount)
          //  * parseInt(currentValue.goodsNum)
        )
      }, 0)
    },
    // 获取发票
    getInvoiceList () {
      let surl = `${this.global.urlNew.universal.invoice}?token=${this.token}&sid=${this.sid}&choose=1`
      this.$http.jsonp(surl)
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          console.log(data)
          if (data.status === '200') {
            this.invoiceList = data.data.resData
          } else if (data.status === '1026' || data.status === '1008') {
            // window.alert('当前登录状态已过期，请重新登录');
            this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
          } else {
            console.log('服务器繁忙，请重试')
          }
        })
    }
  }
}
</script>

<style lang='scss' scoped>
#app {
  .invoice {
    padding: 33px;
    p {
      margin-bottom: 0;
    }
    label {
      margin: 0;
    }
    .title {
      display: flex;
      justify-content: space-between;
      h2 {
        margin-bottom: 25px;
        color: #5c5c5c;
        font-size: 24px;
      }
    }
    .tabs {
      .bar-list {
        border-bottom: 2px solid #efefef;
        display: flex;
        position: relative;
        .tab-bar {
          padding: 23px 21px;
          color: #333;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 1px;
          position: relative;
          cursor: url("../../assets/img/images/mouse3.png"), auto;
          &::before {
            content: '';
            position: absolute;
            width: 110px;
            height: 5px;
            left: 0;
            bottom: 0;
            background: #efefef;
          }
          &.selected {
            color: #333333;
            &::before {
              background: var(--main-color);
            }
          }
        }
      }
      .content {
        ul {
          display: flex;
          flex-wrap: wrap;
          margin-top: 30px;
          margin-bottom: 40px;
          border: 1px solid #dddddd;
          border-bottom: none;
          .table-title {
            background: #f4f6f9;
            padding: 12px 0 12px 20px;
            p {
              line-height: 1;
            }
          }
          li {
            width: 100%;
            margin-bottom: 0;
            padding: 20px 0 20px 20px;
            border-bottom: 1px solid #dddddd;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            .invoice-checkbox {
              margin-top: 0;
              width: 15px;
              height: 15px;
              margin-right: 30px;
              border: 1px solid #dddddd;
              background: #ffffff;
              border-radius: 0;
            }
            label {
              height: 16px;
              display: inline-flex;
              justify-content: flex-start;
              align-content: center;
              align-items: center;
            }
            p {
              font-size: 16px;
              color: #999999;
              width: calc(35% - 220px);
              min-width: 100px;
              text-align: center;
              &:nth-of-type(1) {
                width: 65%;
                text-align: left;
              }
              &:nth-of-type(2) {
                width: 20%;
                min-width: 220px;
              }
            }
          }
        }
        .invoice-pages {
          margin-left: 8px;
          line-height: 36px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          display: flex;
          flex-direction: row-reverse;
          div {
            margin-left: 13px;
            padding: 0 10px;
            background: var(--main-color);
            // color: #333;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
          }
          p {
            font-size: 14px;
            span {
              margin-left: 4px;
              color: #ff0e0e;
              font-size: 18px;
            }
          }
        }
        .no-ticket {
          padding-top: 100px;
          font-size: 24px;
          font-weight: 500;
          text-align: center;
        }
      }
    }
    .info {
      .bar-list {
        border-bottom: 2px solid #efefef;
        display: flex;
        position: relative;
        .tab-bar {
          padding: 23px 21px;
          color: #333;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 1px;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            width: 110px;
            height: 5px;
            left: 0;
            bottom: 0;
            background: var(--main-color);
          }
          &.selected {
            color: #333333;
          }
        }
      }
      .content {
        max-width: 500px;
        padding-top: 21px;
        .input-wrapper {
          margin-right: auto;
          margin-bottom: 27px;
          padding-left: 2em;
          font-size: 14px;
          color: #999;
          line-height: 30px;
          display: flex;
          box-sizing: border-box;
          .input-content {
            margin-left: 16px;
            min-width: 350px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .amount {
              color: #ff0e0e;
              font-size: 21px;
            }
            &.invoice-type {
              justify-content: flex-start;
              label {
                margin-right: 60px;
              }
            }
          }
          label {
            display: flex;
            align-items: center;
            input {
              margin-top: 0;
              margin-right: 6px;
            }
          }
          .input-text {
            width: 100%;
            height: 28px;
            font-size: 15px;
            font-weight: 400;
            color: #999999;
            padding-left: 12px;
            outline: none;
            border: 1px solid #cccccc;
          }
          .input-text::placeholder,
          .input-text::-webkit-input-placeholder {
            font-size: 14px;
            color: #ccc;
          }
          .input-text:-moz-placeholder,
          .input-text::-moz-placeholder,
          .input-text:-ms-input-placeholder {
            font-size: 14px;
            color: #ccc;
          }
          .btn-wrapper {
            margin-left: auto;
            margin-right: auto;
            .btn {
              width: 130px;
              height: 40px;
              font-size: 16px;
              font-weight: 600;
              // color: #4d4d4d;
              color: #fff;
              border: none;
              background: var(--main-color);
              cursor: pointer;
              &.back {
                margin-right: 12px;
                border: 1px solid var(--main-color);
                background: #fff;
                color: var(--main-color);
              }
            }
          }
          &:last-child {
            padding-left: 0;
          }
        }
      }
    }
  }
  @media (max-width: 767px) {
    .tabs {
      .content {
        ul {
          li {
            p {
              &:nth-of-type(1) {
                width: 60%;
              }
              &:nth-of-type(2) {
                width: 30%;
              }
            }
          }
        }
      }
    }
    .info {
      .content {
        .input-wrapper {
          .input-content {
            min-width: auto;
            &.invoice-type {
              display: flex;
              justify-content: space-between;
              label {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/componentsNew/center/OpenInvoice.vue